module.exports = __webpack_public_path__ + "static/media/jeff-sheldon.688ef131.jpg";